import { TSignInParams } from 'types/services';
import { sportingAPI } from 'services/sporting/api';

export const signIn = async (params: TSignInParams): Promise<void> => {
  await sportingAPI.auth.signIn(params);
};
